import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Box, styled, Toolbar} from "@mui/material";
import {TemplateProvider} from "../context/TemplateContext";
import TemplateEditor from "./TemplateEditor/TemplateEditor";
import {useMobile} from "../context/MobileContext";
import {useSelector} from "react-redux";
import {selectGenerationHistoryEnabled} from "../utils/userSlice";
import TemplateList from './TemplateList/TemplateList';
import MyCreations from './Creations/MyCreations';
import AppBar from "./shared/AppBar";

// Styled components
const RootContainer = styled(Box)({
    display: 'flex',
    flexDirection: "column",
    height: "auto",
    minHeight: "100vh"
});

const MainContent = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isMobile'
})<{ isMobile: boolean }>(({isMobile, theme}) => ({
    flexGrow: 1,
    paddingLeft: isMobile ? theme.spacing(0.5) : theme.spacing(3),
    paddingRight: isMobile ? theme.spacing(0.5) : theme.spacing(3),
    paddingBottom: isMobile ? theme.spacing(3) : theme.spacing(3),
    background: "linear-gradient(180deg, #05101D 30.35%, rgba(0, 161, 225, 0.55) 100%)"
}));

const StyledToolbar = styled(Toolbar)({
    // You can add custom styling here if needed
});

const Footer = styled(Box)(({theme}) => ({
    display: 'flex',
    backgroundColor: 'white',
    color: '#05101D',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50px',
    width: '100%',
    fontFamily: theme.typography.fontFamily,
}));

const AppLayout: React.FC = () => {
    const {isMobile} = useMobile();
    const generationHistoryEnabled = useSelector(selectGenerationHistoryEnabled);

    const ROUTER_PAGES = [
        {
            path: "",
            element: <TemplateList/>
        },
        // Off = the route does not exist, so /creations falls through to the
        // catch-all below and redirects home. A team without the feature sees
        // exactly the app it saw before it shipped.
        ...(generationHistoryEnabled ? [{
            path: "creations",
            element: <MyCreations/>
        }] : []),
        {
            path: "template/:templateId",
            element: <TemplateProvider>
                <TemplateEditor/>
            </TemplateProvider>
        },
        {path: "*", element: <Navigate to="/" replace/>}
    ];

    return (
        <RootContainer>
            <AppBar/>
            <MainContent component="main" isMobile={isMobile}>
                <StyledToolbar/>
                <Routes>
                    {ROUTER_PAGES.map((route, index) => (
                        <Route key={index} {...route} />
                    ))}
                </Routes>
            </MainContent>
            <Footer>
                All rights reserved to Sporta &copy;{new Date().getFullYear()}
            </Footer>
        </RootContainer>
    );
};

export default AppLayout;